import { css } from 'styled-components';

export const artworkTileStyles = css`
  aspect-ratio: 4 / 5;
  width: 100%;
  padding: clamp(8px, 1.6vw, 14px);
  background: ${({ theme }) => theme.colors.gallery.mat};
  border: 1px solid ${({ theme }) => theme.colors.gallery.border.subtle};
  border-radius: ${({ theme }) => theme.borderRadius.gallery.soft};
  box-shadow: ${({ theme }) => theme.shadows.gallery.artwork.frame};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    transform ${({ theme }) => theme.transitions.gallery.smooth},
    box-shadow ${({ theme }) => theme.transitions.gallery.smooth},
    border-color ${({ theme }) => theme.transitions.gallery.smooth};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    border-radius: ${({ theme }) => theme.borderRadius.gallery.subtle};
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${({ theme }) => theme.shadows.gallery.artwork.museum};
    border-color: ${({ theme }) => theme.colors.gallery.accent.border};
  }
`;

export const artworkTilePlaceholderStyles = css`
  color: ${({ theme }) => theme.colors.gallery.text.muted};
  background: ${({ theme }) => theme.colors.gallery.mat};
  border: 1px solid ${({ theme }) => theme.colors.gallery.border.subtle};
`;

